import { useState, useEffect } from 'react';
import { ChevronRightIcon, ChevronLeftIcon, CloseIcon } from './gallery/icons';
import { drawings } from '../components/gallery/drawings';
import { styleGrid } from './gallery/stylesGrid';
// const artworks = paintings;
const artworks = drawings;

let styles = {};
const Gallery = () => {
  const [viewMode, setViewMode] = useState('grid');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1920);

  const minSwipeDistance = 50;

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? artworks.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === artworks.length - 1 ? 0 : prev + 1));
  };

  const handleKeyPress = (e) => {
          if (viewMode === 'slideshow') {
      if (e.key === 'ArrowLeft') handlePrevious();
      if (e.key === 'ArrowRight') handleNext();
      if (e.key === 'Escape') setViewMode('grid');
    }
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) handleNext();
    if (isRightSwipe) handlePrevious();
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    window.addEventListener('keydown', handleKeyPress);
   document.getElementById("drawings").classList.add("current");
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [viewMode]);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  const openSlideshow = (index) => {
    setCurrentIndex(index);
    setViewMode('slideshow');
  };

  // Styles
  styles = styleGrid (windowWidth);



  return (
    <div className='container-373' style={styles.container}>

      {/* Grid View */}
      {viewMode === 'grid' && (
        <main style={styles.main}>
          <div style={styles.gridContainer}>
            {artworks.map((artwork, index) => (
              <div
                key={artwork.id}
                style={styles.galleryItem}
                onClick={() => openSlideshow(index)}
              >
                <div 
                  style={styles.imageContainer}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 20px 25px rgba(0, 0, 0, 0.15)';
                    const img = e.currentTarget.querySelector('img');
                    if (img) img.style.transform = 'scale(1.05)';
                    const overlay = e.currentTarget.querySelector('[data-overlay]');
                    if (overlay) overlay.style.opacity = '1';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                    const img = e.currentTarget.querySelector('img');
                    if (img) img.style.transform = 'scale(1)';
                    const overlay = e.currentTarget.querySelector('[data-overlay]');
                    if (overlay) overlay.style.opacity = '0';
                  }}
                >
                  {isLoading ? (
                    <div style={styles.loadingContainer}>
                      <div style={styles.loadingText}>Loading...</div>
                    </div>
                  ) : (
                    <>
                      <img
                        src={artwork.src}
                        alt={artwork.title}
                        style={styles.image}
                        loading="lazy"
                      />
                      <div data-overlay style={styles.imageOverlay}>
                        <div style={styles.overlayContent}>
                          <h3 style={styles.overlayTitle}>{artwork.title}</h3>
                          <p style={styles.overlayYear}>{artwork.year}</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div style={styles.details}>
                  <h3 style={styles.detailTitle}>{artwork.title}</h3>
                  <p style={styles.detailText}>{artwork.year} • {artwork.medium}</p>
                  <p style={styles.detailText}>{artwork.dimensions}</p>
                </div>
              </div>
            ))}
          </div>
        </main>
      )}

      {/* Slideshow View */}
      {viewMode === 'slideshow' && (
        <div className='slide-show-container'
          style={styles.slideshowContainer}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
               
          <button 
              className='close-button'
              onClick={() => setViewMode('grid')}
              style={styles.closeButton}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              aria-label="Close slideshow">
              <CloseIcon />
            </button>
        
          {/* Previous Button */}
          <button
            onClick={handlePrevious}
            style={{...styles.navButton, ...styles.prevButton}}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            }}
            aria-label="Previous image"
          >
            <ChevronLeftIcon />
          </button>

          {/* Next Button */}
          <button
            onClick={handleNext}
            style={{...styles.navButton, ...styles.nextButton}}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            }}
            aria-label="Next image"
          >
            <ChevronRightIcon />
          </button>

          {/* Main Image */}
          <div clasName="show-content" style={styles.slideshowContent}>
            <div className="image-container" style={Object.assign(styles.slideshowImageContainer,{aspectRatio:artworks[currentIndex].aspectRatio})}>
              <img className='current-art-work'
           
                width={artworks[currentIndex].width }
                src={artworks[currentIndex].src}
                alt={artworks[currentIndex].title}
                style={styles.slideshowImage}
              />
            </div>

            {/* Image Details */}
            <div style={styles.slideshowDetails}>
              <h3 style={styles.slideshowTitle}>{artworks[currentIndex].title}</h3>
              <p style={styles.slideshowText}>
                {artworks[currentIndex].year} • {artworks[currentIndex].medium}
              </p>
              <p style={styles.slideshowSmallText}>{artworks[currentIndex].dimensions}</p>
              <p style={styles.counter}>
                {currentIndex + 1} / {artworks.length}
              </p>
            </div>
          </div>

          {/* Thumbnail Strip */}
          <div className="thumbs-strip" style={styles.thumbnailStrip}>
            <div style={styles.thumbnailContainer}>
              {artworks.map((artwork, index) => (
                <button
                  key={artwork.id}
                  onClick={() => setCurrentIndex(index)}
                  style={{
                    ...styles.thumbnail,
                    ...(index === currentIndex ? styles.thumbnailActive : styles.thumbnailInactive)
                  }}
                  onMouseEnter={(e) => {
                    if (index !== currentIndex) {
                      e.currentTarget.style.opacity = '1';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (index !== currentIndex) {
                      e.currentTarget.style.opacity = '0.6';
                    }
                  }}
                >
                  <img
                    src={artwork.src}
                    alt={`Thumbnail ${index + 1}`}
                    style={styles.thumbnailImage}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
